import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryTab,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeCollections } from '../actions';
import CollectionsActions from '../containers/CollectionsActions';
import CollectionsPanel from '../components/CollectionsPanel';

export default {
  ...tabTemplate('collections', CollectionsPanel, matchSingleUrl(['collections']), CollectionsActions),
  ...tabCloser('closeCollectionsTab', closeCollections),
  ...tabIcons('object group', 'far fa-'),
  access: ({ datasets }) => datasets.read,
  componentState: ({ url }) => categoryTab(url, 'all'),
  order: 300,
  position: 'top-right',
};
